/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LineItem } from "./LineItem";
import {
  LineItemFromJSON,
  LineItemFromJSONTyped,
  LineItemToJSON,
  LineItemToJSONTyped,
} from "./LineItem";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";
import type { QuoteTestScenarioMetadata } from "./QuoteTestScenarioMetadata";
import {
  QuoteTestScenarioMetadataFromJSON,
  QuoteTestScenarioMetadataFromJSONTyped,
  QuoteTestScenarioMetadataToJSON,
  QuoteTestScenarioMetadataToJSONTyped,
} from "./QuoteTestScenarioMetadata";

/**
 *
 * @export
 * @interface PostQuoteTestScenarioBody
 */
export interface PostQuoteTestScenarioBody {
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestScenarioBody
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestScenarioBody
   */
  description: string;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof PostQuoteTestScenarioBody
   */
  lineItems: Array<LineItem>;
  /**
   *
   * @type {Location}
   * @memberof PostQuoteTestScenarioBody
   */
  pickupLocation: Location;
  /**
   *
   * @type {Location}
   * @memberof PostQuoteTestScenarioBody
   */
  deliveryLocation: Location;
  /**
   *
   * @type {QuoteTestScenarioMetadata}
   * @memberof PostQuoteTestScenarioBody
   */
  metadata?: QuoteTestScenarioMetadata | null;
}

/**
 * Check if a given object implements the PostQuoteTestScenarioBody interface.
 */
export function instanceOfPostQuoteTestScenarioBody(
  value: object,
): value is PostQuoteTestScenarioBody {
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined)
    return false;
  if (!("lineItems" in value) || value["lineItems"] === undefined) return false;
  if (!("pickupLocation" in value) || value["pickupLocation"] === undefined)
    return false;
  if (!("deliveryLocation" in value) || value["deliveryLocation"] === undefined)
    return false;
  return true;
}

export function PostQuoteTestScenarioBodyFromJSON(
  json: any,
): PostQuoteTestScenarioBody {
  return PostQuoteTestScenarioBodyFromJSONTyped(json, false);
}

export function PostQuoteTestScenarioBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PostQuoteTestScenarioBody {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    description: json["description"],
    lineItems: (json["lineItems"] as Array<any>).map(LineItemFromJSON),
    pickupLocation: LocationFromJSON(json["pickupLocation"]),
    deliveryLocation: LocationFromJSON(json["deliveryLocation"]),
    metadata:
      json["metadata"] == null
        ? undefined
        : QuoteTestScenarioMetadataFromJSON(json["metadata"]),
  };
}

export function PostQuoteTestScenarioBodyToJSON(
  json: any,
): PostQuoteTestScenarioBody {
  return PostQuoteTestScenarioBodyToJSONTyped(json, false);
}

export function PostQuoteTestScenarioBodyToJSONTyped(
  value?: PostQuoteTestScenarioBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    description: value["description"],
    lineItems: (value["lineItems"] as Array<any>).map(LineItemToJSON),
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
    metadata: QuoteTestScenarioMetadataToJSON(value["metadata"]),
  };
}
